import React from 'react'
import ServiceAreaLegend, { ServiceAreaLegendProps } from './ServiceArea'
import ZoneLegend, { ZoneLegendProps } from './Zone'
import VehicleLegend, { VehicleLegendProps } from './Vehicle'
import JobLegend, { JobLegendProps } from './Job'

export { ServiceAreaLegend, ZoneLegend, VehicleLegend, JobLegend }
export type LegendType = 'ServiceArea' | 'Zone' | 'Vehicle' | 'Job'

// have to use Omit<onClose> because of: https://github.com/microsoft/TypeScript/issues/31501
export type LegendProps =
  | ({ type: 'Zone' } & Omit<ZoneLegendProps, 'onClose'>)
  | ({ type: 'Vehicle' } & Omit<VehicleLegendProps, 'onClose'>)
  | ({
      type: 'ServiceArea'
    } & Omit<ServiceAreaLegendProps, 'onClose'>)
  | ({
      type: 'Job'
    } & Omit<JobLegendProps, 'onClose'>)
  | { type: null }

const Legend = (props: LegendProps & { onClose: () => void }) => {
  switch (props.type) {
    case 'ServiceArea': {
      return <ServiceAreaLegend {...props} />
    }
    case 'Zone': {
      return <ZoneLegend {...props} />
    }
    case 'Vehicle': {
      return <VehicleLegend {...props} />
    }
    case 'Job': {
      return <JobLegend {...props} />
    }
    default: {
      return null
    }
  }
}

export default Legend
